import { DropdownStyled, MenuStyled } from './select-program-dropdown.styles';

export const Dropdown = ({ children, isOpen, target }) => (
  <DropdownStyled data-testid="program-select-dropwodn">
    {target}
    {isOpen ? <MenuStyled>{children}</MenuStyled> : null}
  </DropdownStyled>
);
